export default {
  rdstation: {}
}
